import { Injectable } from "@angular/core";
import * as i18nIsoCountries from "i18n-iso-countries";
import { LocalizedCountryNames } from "i18n-iso-countries";
import { TranslateService } from "@ngx-translate/core";
import de from "i18n-iso-countries/langs/de.json";
import en from "i18n-iso-countries/langs/en.json";
import fr from "i18n-iso-countries/langs/fr.json";
import it from "i18n-iso-countries/langs/it.json";

@Injectable({
  providedIn: "root"
})
export class CountryService {
  constructor(private translationService: TranslateService) {
    i18nIsoCountries.registerLocale(de);
    i18nIsoCountries.registerLocale(en);
    i18nIsoCountries.registerLocale(fr);
    i18nIsoCountries.registerLocale(it);
  }

  getCountries(): LocalizedCountryNames<{ select: "official" }> {
    return i18nIsoCountries.getNames(this.translationService.getCurrentLang() ?? "en", {
      select: "official"
    });
  }

  getCountryName(countryCode: string): string | undefined {
    return i18nIsoCountries.getName(countryCode, this.translationService.getCurrentLang() ?? "en");
  }
}
